"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postRequest = exports.deleteRequest = exports.getRequest = void 0;
const prepareGetResponse = (response) => {
    if (response.ok) {
        return response.json();
    }
    throw new Error(response.statusText);
};
const pepareDeleteResponse = (response) => {
    if (!response.ok || response.status !== 204) {
        throw new Error(response.statusText);
    }
};
const preparePostResponse = async (response) => {
    const contentType = response.headers.get('content-type');
    const isJsonContentType = contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json');
    if (response.ok || response.status === 201) {
        return response.text();
    }
    if (response.status === 400) {
        if (isJsonContentType) {
            const error = await response.json();
            throw new Error(error);
        }
        else {
            const error = await response.text();
            throw new Error(error);
        }
    }
    throw new Error(response.statusText);
};
const getRequest = (authService, resourceHostId, url, headers) => authService.get(resourceHostId, url, headers)
    .then((response) => prepareGetResponse(response));
exports.getRequest = getRequest;
const deleteRequest = (authService, resourceHostId, url, headers) => authService.delete(resourceHostId, url, headers)
    .then((response) => pepareDeleteResponse(response));
exports.deleteRequest = deleteRequest;
const postRequest = async (authService, resourceHostId, url, payload, headers) => {
    const response = await authService.post(resourceHostId, url, JSON.stringify(payload), headers);
    return preparePostResponse(response);
};
exports.postRequest = postRequest;
//# sourceMappingURL=fetch.js.map